import {
  FormField,
  RadioButton,
  RadioButtonGroup,
  Select,
  SelectOption,
  TextInput,
} from "@justworkshr/milo-form";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { ConfigType, SchemaType } from "./config";
import { ChangeEvent } from "react";

export default function FormFragment() {
  const { t } = useTranslation();
  const { errors, touched, handleBlur, values, setFieldValue, handleChange } =
    useFormikContext<SchemaType>();

  const handleBooleanChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.name, event.target.value === "true");
  };

  const fieldErrorHandler = (name: keyof ConfigType["initialValues"]) =>
    errors[name] && touched[name] ? errors[name] : undefined;

  return (
    <>
      <FormField
        required
        name="probationPeriodDays"
        label={t("Probation Period")}
        error={fieldErrorHandler("probationPeriodDays")}
      >
        <Select
          name="probationPeriodDays"
          placeholder={t("Select probation period days")}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.probationPeriodDays}
        >
          <SelectOption value="0">{t("None")}</SelectOption>
          <SelectOption value="180">{t("180 days")}</SelectOption>
        </Select>
      </FormField>
      <FormField
        required
        name="gbPtoAllowanceDays"
        label={t("PTO Allowance Days")}
        error={fieldErrorHandler("gbPtoAllowanceDays")}
      >
        <TextInput
          required
          type="number"
          name="gbPtoAllowanceDays"
          onChange={handleChange}
          onBlur={handleBlur}
          value={String(values.gbPtoAllowanceDays)}
        />
      </FormField>
      <FormField
        name="gbDiscretionaryBonuses"
        required
        label={t("Will you be offering the employee discretionary bonuses?")}
        error={fieldErrorHandler("gbDiscretionaryBonuses")}
      >
        <RadioButtonGroup
          name="gbDiscretionaryBonuses"
          onChange={handleBooleanChange}
          onBlur={handleBlur}
          value={String(values.gbDiscretionaryBonuses)}
        >
          <RadioButton name="yes" value="true" label={t("Yes")} />
          <RadioButton name="no" value="false" label={t("No")} />
        </RadioButtonGroup>
      </FormField>
      <FormField
        name="gbEquity"
        required
        label={t("Will you be offering the employee equity?")}
        error={fieldErrorHandler("gbEquity")}
      >
        <RadioButtonGroup
          name="gbEquity"
          onChange={handleBooleanChange}
          onBlur={handleBlur}
          value={String(values.gbEquity)}
        >
          <RadioButton name="yes" value="true" label={t("Yes")} />
          <RadioButton name="no" value="false" label={t("No")} />
        </RadioButtonGroup>
      </FormField>
      <FormField
        name="gbAdditionalHealthcareBenefits"
        required
        label={t(
          "Will you be offering the employee additional healthcare benefits?"
        )}
        error={fieldErrorHandler("gbAdditionalHealthcareBenefits")}
      >
        <RadioButtonGroup
          name="gbAdditionalHealthcareBenefits"
          onChange={handleBooleanChange}
          onBlur={handleBlur}
          value={String(values.gbAdditionalHealthcareBenefits)}
        >
          <RadioButton name="yes" value="true" label={t("Yes")} />
          <RadioButton name="no" value="false" label={t("No")} />
        </RadioButtonGroup>
      </FormField>
    </>
  );
}
